import React, { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router'
import { useAuth } from '../hooks/useAuth'
import { Bars3Icon, XMarkIcon, UserCircleIcon, MagnifyingGlassIcon, Cog6ToothIcon, RssIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import ThemeToggle from './ThemeToggle'
import SettingsModal from './SettingsModal'

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [settingsOpen, setSettingsOpen] = useState(false)
  const { user, isAdmin, logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  // Check if we're on the homepage
  const isHomePage = location.pathname === '/'

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  return (
    <header className="shadow-xs bg-[#ffa724]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="shrink-0">
            {isHomePage ? (
              <a href="https://domoticagrunn.nl/" className="flex items-center space-x-3">
                <img
                  src="https://domoticagrunn.nl/assets/domoticaGrunn_logo.png"
                  alt="domoticaGrunn logo"
                  className="w-8 h-8"
                />
                <span className="text-xl font-bold text-black">domoticaGrunn</span>
              </a>
            ) : (
              <Link to="/" className="flex items-center space-x-3">
                <img
                  src="https://domoticagrunn.nl/assets/domoticaGrunn_logo.png"
                  alt="domoticaGrunn logo"
                  className="w-8 h-8"
                />
                <span className="text-xl font-bold text-black">domoticaGrunn</span>
              </Link>
            )}
          </div>

          {/* Right Section with RSS, Theme Toggle and User/Admin Controls */}
          <div className="hidden md:flex items-center space-x-4">
            {/* Theme Toggle */}
            <ThemeToggle />

            {/* JSON Feed Icon */}
            <a
              href={`feed:${window.location.origin}/api/meetups/feed.json`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-black hover:text-gray-700 transition-colors"
              title="JSON Feed"
            >
              <RssIcon className="h-6 w-6" />
            </a>

            {user ? (
              <div className="flex items-center space-x-4">
                {isAdmin && (
                  <Link
                    to="/admin/dashboard"
                    className="text-black hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                  >
                    Admin
                  </Link>
                )}
                <button
                  onClick={() => setSettingsOpen(true)}
                  className="text-black hover:text-gray-700 transition-colors"
                  title="Instellingen"
                >
                  <Cog6ToothIcon className="h-6 w-6" />
                </button>
                <button
                  onClick={handleLogout}
                  className="text-black hover:text-gray-700 text-sm font-medium transition-colors"
                >
                  Uitloggen
                </button>
              </div>
            ) : null}
          </div>

          {/* Mobile icons */}
          <div className="md:hidden flex items-center space-x-2">
            <ThemeToggle />
            <a
              href={`feed:${window.location.origin}/api/meetups/feed.json`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-black hover:text-gray-700 p-2"
              title="JSON Feed"
            >
              <RssIcon className="h-6 w-6" />
            </a>
            {user ? (
              <>
                <button
                  onClick={() => setSettingsOpen(true)}
                  className="text-black hover:text-gray-700 p-2"
                  title="Instellingen"
                >
                  <Cog6ToothIcon className="h-6 w-6" />
                </button>
                <button
                  onClick={handleLogout}
                  className="text-black hover:text-gray-700 p-2"
                  title="Uitloggen"
                >
                  <ArrowRightOnRectangleIcon className="h-6 w-6" />
                </button>
              </>
            ) : null}
          </div>
        </div>
      </div>

      {/* Settings Modal */}
      <SettingsModal isOpen={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </header>
  )
}

export default Header